import styled from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { PRODUCT_PREVIEW_HEIGHT } from './constants';

export const ProductsPreviewContainer = styled(Flex)
    .withConfig({
        displayName: 'ProductsPreviewContainer',
    })
    .attrs((props) => ({
        height: PRODUCT_PREVIEW_HEIGHT,
        width: '100%',
        px: 0.75,
        py: 0.5,
        pl: 1,
        spacing: 0.5,
        overflow: 'hidden',
        cursor: 'pointer',
        ...props,
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    }))``;

export const ProductContent = styled(Box)
    .withConfig({
        displayName: 'ProductContent',
    })
    .attrs({
        overflow: 'hidden',
        height: '100%',
    })`
    align-content: center;
`;

export const Title = styled(Typography)
    .withConfig({
        displayName: 'Title',
    })
    .attrs((props) => ({
        ...props,
        variant: 'caption',
        lines: 1,
    }))`
    line-break: anywhere;
`;

export const MoreProductsBadge = styled(Typography)
    .withConfig({
        displayName: 'MoreProductsBadge',
    })
    .attrs({
        backgroundColor: 'var(--control-secondary-background)',
        p: 0.75,
        borderRadius: 4,
        weight: 'bold',
        variant: 'caption2',
    })``;
